<script>
    import entry from '../form/ib-form-entry.vue';
    import button from './ib-button.vue'

    /**
     * A form control that emits a boolean value and appears as a button with solid style if true,
     * outline style if false.
     */
    export default {
        name: 'ib-button-toggle',

        mixins: [
            entry,
            button
        ],

        computed: {
            _class() {
                const tone = this.tone || 'accent';
                const appearance = this.appearance || (this.ivalue ? null : 'outline');
                return {
                    [tone]: tone,
                    [appearance]: appearance,
                    _busy: this.busy
                };
            }
        },

        methods: {
            _click() {
                this._emit(!this.ivalue);
                this.$emit('change');
            }
        }
    }
</script>

<ib-example id="basic" name="Basic">
    <template lang="pug">
        ib-button-toggle Toggle Me!
    </template>
</ib-example>

<ib-example id="moreless" name="Show More/Show Less">
    <template lang="pug">
        p This is some text.
            |  
            span(id="moretext", v-show="more") This is even more text. I bet people aren't even concerned with this text at all.
            |  
            ib-button-toggle(appearance="link", class="fs7", v-model="more") {{ more ? 'Show Less' : 'Show More' }}
    </template>
    <script>
        {
            data() {
                return {
                    more: false
                };
            }
        }
    </script>
</ib-example>
